<template>
  <section>
    <div @click="edit" class="clearfix documentItem draft clickable">
      <div class="logo">
        <div class="cover-small">
          <div class="cover-image-container">
            <div class="cover-outer-align">
              <div class="cover-inner-align">
                <i class="fal fa-file-edit fa-2x" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="information w-light">
        <h5>{{ details.document.name }} {{ details.documentVersion.version }}</h5>
        <small v-bind:class="{ 'd-block d-lg-none': !showMinimal }">
          {{$t('DOCUMENTS.DRAFT.LAST_UPDATE')}}: {{ $moment(details.documentVersion.updatedDate) | moment("YYYY-MM-DD HH:mm") }}
          <br />
          {{ details.documentVersion.dclIdentity }}
        </small>
      </div>
      <div class="extrainformation w-light d-none d-lg-table-cell" v-if="!showMinimal">
          {{ details.documentVersion.dclIdentity }}
      </div>
      <div class="extrainformation w-light d-none d-lg-table-cell" v-if="!showMinimal">
          {{ $moment(details.documentVersion.updatedDate) | moment("YYYY-MM-DD HH:mm") }}
      </div>
    </div>

    <b-modal v-model="modalEdit" size="lg" centered no-fade>
      <div slot="modal-header">{{$t('DOCUMENTS.DRAFT.TITLE')}}</div>
      <div class="p-4 text-center" v-if="modalEditLoading">
        <img src="img/loading.gif" />
        <h5 style="margin: 0; padding: 0;">{{$t('DOCUMENTS.DRAFT.PROCESSING')}}</h5>
      </div>
      <div class="p-4" v-if="modalEditLoading === false">
        <form enctype="multipart/form-data">
          <div class="form-group row">
            <label class="col-form-label">{{ $t('DOCUMENTS.DRAFT.INPUT_NAME') }}</label>
            <input
              readonly
              class="form-control-plaintext"
              v-model="editFormName"
              type="text"
              name="name"
              required
              v-on:keyup.enter="onEnter"
            />
          </div>

          <div class="form-group row">
            <label class="col-form-label">{{ $t('DOCUMENTS.DRAFT.INPUT_VERSION') }}</label>
            <input class="form-control" v-on:keyup.enter="onEnter" v-model="editFormVersion" type="text" name="name" required />
          </div>

          <div class="form-group row">
            <label class="col-form-label">
              {{ $t('DOCUMENTS.DRAFT.DOCUMENT') }} -
              <a
                class="btn btn-primary btn-sm"
                :href="downloadUrl"
              >{{ $t('DOCUMENTS.DRAFT.DOWNLOAD_CURRENT_DOCUMENT') }}</a>
            </label>
            <b-form-file
              v-model="editFormDocument"
              :state="Boolean(editFormDocument)"
              :placeholder="placeHolder"
            ></b-form-file>
          </div>

          <div class="form-group row">
            <b-form-group :label="$t('DOCUMENTS.DRAFT.INPUT_PUBLISH')">
              <b-form-radio-group
                stacked
                id="editFormPublish"
                v-model="editFormPublish"
                name="publish"
                v-on:keyup.enter="onEnter"
              >
                <b-form-radio value="0">{{ $t('NO')}}</b-form-radio>
                <b-form-radio value="1">{{ $t('YES')}}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
        </form>
      </div>
      <div slot="modal-footer" class="w-100">
        <div v-if="modalEditLoading === false">
          <b-btn @click="hideEditSection">{{ $t('CLOSE')}}</b-btn>

          <b-button
            variant="primary"
            class="btn-fill"
            @click="editDocument"
          >{{ $t('DOCUMENTS.DRAFT.UPDATE')}}</b-button>
        </div>
      </div>
    </b-modal>
  </section>
</template>
<script>
export default {
  props: ["item","small"],
  data() {
    return {
      showMinimal: this.small,
      modalEdit: false,
      modalEditLoading: false,
      editFormName: this.item.document.name,
      editFormVersion: this.item.documentVersion.version,
      editFormDocument: "",
      editFormPublish: 0,
      details: this.item,
      downloadUrl:
        process.env.VUE_APP_BACKEND +
        "/document/download/" +
        this.item.documentVersion.dclIdentity +
        ".pdf",
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    edit() {
      this.modalEdit = true;
    },
    hideEditSection() {
      this.modalEdit = false;
      this.modalEditLoading = false;
    },
    showDetail() {
      return null;
    },
    onEnter: function() {
       this.editDocument();
    },
    editDocument: function() {
      let self = this;
      let formData = new FormData();
      formData.append("DraftId", this.item.documentVersion.id);
      if(this.editFormDocument === "")
      {
        formData.append("Document", this.editFormDocument);
      }
      formData.append("Version", this.editFormVersion);
      formData.append("Publish", this.editFormPublish);
      this.modalEditLoading = true;
      this.$http
        .post(
          process.env.VUE_APP_BACKEND + `/document/version/edit`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(function(response) {
          self.modalEditLoading = false;
          self.modalEdit = false;
          self.details.documentVersion = response.data.documentVersion;
          if (self.details.documentVersion.published == 1) {
            self.hideEditSection();
          }
          self.$noty.info(self.$t("DOCUMENTS.DRAFT.SUCCESS.UPDATED_DOCUMENT"));
        })
        .catch(function(error) {
          self.modalEditLoading = false;
          self.$noty.error(self.$t(error.response.data));
        });
    }
  },
  computed: {
    placeHolder() {
      return this.$t("DOCUMENTS.DRAFT.SELECT_DOCUMENT");
    },
    documentName() {
      return (
        this.details.document.name + ":" + this.details.documentVersion.version
      );
    }
  }
};
</script>
<style>
</style>